<template>
    <header>
        <div class="hero"
             v-if="backgroundImageUrl"
             :style="{ backgroundImage: `url(${backgroundImageUrl})` }"
        >
            <div class="hero-content">

                <div class="hero-text">
                    <h1
                        class="header__title"
                        v-if="headline"
                    >{{ headline }}</h1>
                    <h4
                        class="header__title"
                        v-if="tagline"
                    >{{ tagline }}</h4>
                </div>

            </div>
        </div>
    </header>
</template>

<script>
export default {
    props: {
        backgroundImageUrl: {
            default: null,
            required: false,
            type: String
        },
        headline: {
            default: null,
            required: false,
            type: String
        },
        tagline: {
            default: null,
            required: false,
            type: String
        }
    }
}
</script>

<style lang="postcss" scoped>
@import 'theme';

.hero {
    background-size: cover;
    background-position: center 75%;
    background-repeat: no-repeat;
    padding: 0;
    height: 426px;
    align-items: flex-end;
    justify-content: flex-end;
    display: flex;
    flex-direction: column;
}

.hero-content {
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    width: 100%;
    max-width: 960px;
    margin: 0 auto;
    padding: 24px 16px;

}

.hero-text {
    padding-bottom: 2rem;
    text-align: right;
    text-shadow: 2px 2px 3px #000;
}

</style>